import React from "react";
import { Guitar } from "lucide-react";
import "./index.css";

function App() {
  return (
    <div className="container">
      <div className="background-overlay" />

      <div className="content">
        <div className="icon-wrapper">
          <Guitar className="icon" strokeWidth={1.5} />
        </div>

        <h1 className="title animate-fade-in">GUITAR CHORDS</h1>

        <div className="subtitle-wrapper">
          <p className="subtitle animate-slide-up">Coming Soon...</p>
        </div>
      </div>

      <div className="decorative-line" />
    </div>
  );
}

export default App;
